import { AnimatePresence, motion, Motions } from '@studio/design-system/motion';
import type { StatusDevice } from '@tryiris-ai/common.protojs/agent/v1/agent';
import type { ReactElement } from 'react';
import { DestinationCard } from './destination-card.js';
import type { Destination } from './store/destinations.js';

type DestinationsGridProps = {
  destinations: Destination[];
  videoSources: {
    id: string;
    name: string;
    egress: StatusDevice['egress'];
    type: 'video' | 'audio';
    videoCodec: string | undefined;
  }[];
  onEditDestination: (destination: Destination) => void;
  streamProfile?: string | undefined;
};

export const DestinationsGrid = ({
  destinations,
  videoSources,
  onEditDestination,
  streamProfile,
  ...props
}: DestinationsGridProps & { 'data-stag'?: string }): ReactElement | null => {
  if (!destinations.length) return null;
  return (
    <div
      className='mb-6 mt-4 grid max-h-[450px] grid-cols-2 gap-6 overflow-y-auto'
      data-stag='rtmp.destinations.grid.container'
      {...props}
    >
      <AnimatePresence initial={true}>
        {destinations.map((destination, index) => (
          <motion.div
            key={destination.id}
            {...Motions.Fade}
            data-stag={`rtmp.destinations.grid.item.${index}`}
          >
            <DestinationCard
              destination={destination}
              videoSources={videoSources}
              onEditDestination={onEditDestination}
              streamProfile={streamProfile}
              data-stag={`rtmp.destinations.card.${destination.id}`}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};
